// LoadingScreen.jsx
import { Box, Image, Text, VStack } from "@chakra-ui/react";
import scissor from "../assets/loadinganderror/scissor.png";

const LoadingScreen = () => {
  return (
    <Box
      bg="#FFE2AF"
      h="100vh"
      w="100vw"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <VStack spacing={2}>
        <Image
          src={scissor}
          alt="Loading Scissor"
          height={["60px", "80px", "120px"]}
          width="auto"
          objectFit="contain"
        />

        <Text fontSize={["sm", "md", "lg"]} fontWeight="medium" color="black">
          Loading please wait.................
        </Text>
      </VStack>
    </Box>
  );
};

export default LoadingScreen;
